/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Draft_BodyInputs */

const en_us2_today_draft_body = /** @type {(inputs: Today_Draft_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing changes in your plan until you accept it.`)
};

const pt_br2_today_draft_body = /** @type {(inputs: Today_Draft_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada muda no seu plano até você aceitar.`)
};

const es_419_today_draft_body = /** @type {(inputs: Today_Draft_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada cambia en tu plan hasta que lo aceptes.`)
};

const pt_pt2_today_draft_body = /** @type {(inputs: Today_Draft_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada muda no teu plano até o aceitares.`)
};

const fr_fr2_today_draft_body = /** @type {(inputs: Today_Draft_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien ne change dans ton programme tant que tu ne l'as pas accepté.`)
};

const de_de2_today_draft_body = /** @type {(inputs: Today_Draft_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An deinem Plan ändert sich nichts, bis du zustimmst.`)
};

const it_it2_today_draft_body = /** @type {(inputs: Today_Draft_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nella tua scheda non cambia nulla finché non la accetti.`)
};

/**
* | output |
* | --- |
* | "Nothing changes in your plan until you accept it." |
*
* @param {Today_Draft_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_draft_body = /** @type {((inputs?: Today_Draft_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Draft_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_draft_body(inputs)
	if (locale === "es-419") return es_419_today_draft_body(inputs)
	if (locale === "pt-PT") return pt_pt2_today_draft_body(inputs)
	if (locale === "fr-FR") return fr_fr2_today_draft_body(inputs)
	if (locale === "de-DE") return de_de2_today_draft_body(inputs)
	if (locale === "it-IT") return it_it2_today_draft_body(inputs)
	return en_us2_today_draft_body(inputs)
});
export { today_draft_body as "today.draft_body" }